var msg = new Array();
msg['ERR_CARRIERMISSING']='Sie müssen eine Versandart zuerst wählen.';
msg['ERR_CARRIER_COST_MISSING']='Keine Gebühr für ausgewählte Land Träger und damit Gewicht.';
msg['ERR_CLIENTMANDATORYFIELDS']='Füllen Sie alle Pflichtfelder.';
msg['ERR_FILLEMAILFIELD']='Füllen Sie das E-Mail-Feld';
msg['ERR_INVALIDMAIL']='Ungültige E-Mail-Adresse.';
msg['ERR_LOGININVALID']='Ungültige E-Mail oder Passwort';
msg['ERR_LOGINREQUIRED']='Login erforderlich';
msg['ERR_MISSINGFIELDS']='Füllen Sie alle Felder aus.';
msg['ERR_NOSIZESELECTED']='Sie müssen eine Größe auswählen';
msg['ERR_PRIVACY']='Sie müssen Datenschutzerklärung akzeptieren.';
msg['ERR_USEREXISTS']='User existiert.';
msg['LABEL_ALREADYREGISTEREDUSERES']='Already registered users';
msg['LABEL_ARTICLES']='produkte';
msg['LABEL_INVITES_ALREADY_SENT']='Users already invited';
msg['LABEL_NOTAPPLICABLE']='Nicht anwendbar';
msg['LABEL_NOTSENTINVITES']='Unsent invites';
msg['LABEL_SELECTALL']='Select all';
msg['LABEL_SENTINVITES']='Sent invites';
msg['LABEL_SUBMIT']='Submit';
msg['LABEL_WARNING']='Warnung';
msg['MSG_ADDEDTOCART']='Produkte in den Korb einfügen';
msg['MSG_ADDEDTOWISHLIST']='Produkt auf Ihrer Wunschliste hinzugefügt';
msg['MSG_APPLIEDVATCHANGED']='After billing data upgrade, VAT applied to your order changed. Check the new amount ones page gets reloaded.';
msg['MSG_COUPON_ERROR']='Codice coupon inserito non valido o inserito precedentemente.';
msg['MSG_COUPON_VALID']='Codice coupon inserito validato con successo.';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Nur um Reservierung Modus wird aktiviert und Versandgebühren werden Sie per E-Mail gesendet.';
msg['MSG_EXTRAUELIMIT']='Der Mindestbetrag soll nicht niedriger als 2000.00 &euro; sein ';
msg['MSG_GENERIC_ERROR']='Leider ist ein Fehler aufgetreten.';
msg['MSG_INSUFFICIENT_STOCK']='Entschuldigung, im Moment haben wir nicht genug Verfügbarkeit der Produkte.';
msg['MSG_MAILSENT']='E-Mail gesendet';
msg['MSG_MESSAGE_PRODUCTSHARE']='Nachricht';
msg['MSG_MIXED_CART']='Dieses Produkt kann nicht zusammen mit Produkten in Ihrem Warenkorb gekauft werden, weil es in ein anderem Lager ist';
msg['MSG_MIXED_INTANGIBLE']='Dieses Produkt kann nicht zusammen mit Produkten gekauft werden Sie bereits in Ihrem Warenkorb.';
msg['MSG_PAYMENT_PENDING'] = 'Ausstehende Zahlung';
msg['MSG_PROFILECONSENT_SAVED'] = 'Wir haben ihre Kontaktvoreinstellungen aktualisiert';
msg['MSG_RECOVEREMAILSENT']='Überprüfen Sie Ihre E-Mail und klicken Sie auf dem Link, um die Änderung zu bestätigen.';
msg['MSG_RECOVEREMAILSENT_ERROR']='Achtung: Sie sind mit dieser E-Mail-Adresse nicht angemeldet oder Sie setzen Ihr Passwort bereits zurück.';
msg['MSG_RULE_REJECT']='Product cannot be added to cart because of rule :rule';
msg['MSG_SELECT_PROVINCE']='Seleziona una provincia';
msg['MSG_SENDER_PRODUCTSHARE']='Ihr Name';
msg['MSG_SUBJECT_PRODUCTSHARE']=' etwas mit Ihnen geteilt';
msg['MSG_SUBSCRIBED'] = 'Iscritto con successo';
msg['MSG_SUBSCRIPTION_FAILURE']='Make sure you do not have any other active subscription.';
msg['MSG_SUBSCRIPTION_NO_RENEWABLE'] = 'Es sind zu viele Tage vergangen, so dass das Abonnement nicht mehr verlängert werden kann';
msg['MSG_WAIT']='Warten Sie bitte ...';
msg['msg.form.invalidtype'] = 'Es ist ein Fehler aufgetreten. Bitte kontaktieren Sie die Verwaltung und melden Sie den folgenden Fehler: "Kontaktart ungültig oder abwesend."';
msg['msg.form.invalidemail'] = 'Ungültige oder fehlende E-Mail';
msg['msg.form.invalidrecipients'] = 'Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an die Verwaltung und melden Sie den folgenden Fehler: "Kontaktempfänger ungültig oder abwesend."';

var portal_livestock_available='AVAILABLE';
var portal_livestock_soldout='SOLD OUT';

var activity_online_shop = 'Online-Shop';
var activity_shop = 'Shop';
var activity_private_sales = 'Private Verkaufe';
var activity_outlet = 'Outlet';
var activity_online_outlet = 'Online Outlet';
var activity_store_chain = 'Ladenkette';
var activity_purchasing_group = 'Einkauf Gruppe';
var activity_broker = 'Broker/Handelsvertreter';
var activity_ebay_amazon = 'Shop Ebay/Amazon';
var activity_other = 'Anders';

var general='General';
var general_personaldata='Personal data';
var general_olduser='Registered user';
var general_newuser='New user';
var general_username="Username";
var general_password="Password";
var general_contacts='Contacts';
var general_phone='Phone Nr';
var general_skype='Skype';
var general_website='WebSite';
var general_fax='Fax';
var general_firstname='First name';
var general_lastname='Last name';
var general_company='Company';
var general_birth='Date of birth';
var general_code='Code';
var general_model='Model';
var general_quantity='Quantity';
var general_availability='Availability';
var general_price='Price';
var general_warning='Warning';
var general_dispatchto='Company name/Adressee';
var general_careof='C/O';
var general_vat='VAT';
var general_address='Address';
var general_addresstype='Address type';
var general_addressnumber='Number';
var general_city='City';
var general_prov='Prov';
var general_zip='ZIP';
var general_mobile='Mobile';
var general_notes='Notes';
var general_orders='Ordini';
var general_fgfdiscounts='Friends and discounts';
var general_myprofile='My Profile';
var general_pieces='pc';
var general_size_table='Size Table';
var general_details='Details';
var general_invoice='Invoice';
var general_creditnote='Gutschrift';
var general_cart= 'Shopping Cart';
var general_country='Country';
var general_carrier='Carrier';
var general_dispatch_address='Dispatch Address';
var general_invoice_address='Invoice Address';
var general_receive_newsletter='Receive newsletter';
var general_copydispatchfrombilldata='Kopieren Sie aus Verrechnungdaten';
var general_instructions="Anweisungen";
var general_add="Hinzufügen";
var general_status="Status";
var general_toomanyfilters="Hai raggiunto il numero massimo di filtri permessi.";

var help_addresstype='Via, Piazza, Corso, ...';
var help_address='Street name';
var help_dispatchmobile='This number will be used by the carrier.';
var help_ordercfpiva='A blank value will automatically add a 20% VAT to the order value.';
var help_cf='Insert your SSN';

var buttons_save='Save';
var buttons_changepw='Change password';
var buttons_close='Close';
var buttons_continue='Continue';
var buttons_confirm='Confirm';
var buttons_cancel='Cancel';
var buttons_invite='Invita';
var buttons_continueshopping='Continue with shopping';
var buttons_gocheckout='Bestätigen';

var messages_product_soldout='Product sold out.';
var messages_noselection='No selection';
var messages_invaliddata='Invalid data.';
var messages_recoverpassword='Recover password';
var messages_recoverpassword_info='Insert the email you subscribed with<br/>You will receive an email with the istructions to get a recover your password';
var messages_invitefriends='Invite your friends';
var messages_confirmpassword='Confirm password';
var messages_sendingmail='Sending mail...';
var messages_mailsent='Email sent.';
var messages_password='Password';
var messages_confirmpassword='Password confirm';
var messages_requiredfield='Pflichtfeld';

var subscribe_personaldata='Personal data';
var subscribe_privacyintro='You have to accept the following condition to proceed with the subscription.';
var subscribe_privacydisclaimer='You have to accept the privacy displaimer to proceed with the subscription.'
var subscribe_privacy1='I accept the pricacy disclaimer';
var subscribe_privacy2='I accept that my personal data can be used by other firms for marketing campaigns (optional)';

var order_status='Status'
var order_date='Date'
var order_dispatchdate='Dispatched';

var returnedgoods_requests="Rückwaren Anfrage";
var returnedgoods_motivations="Rückwaren Motivation";
var returnedgoods_requestcode="Rückwaren Kode";
var returnedgoods_requestdate="Datum der Anfrage Date";
var returnedgoods_motivations_1="Das Produkt gefällt mir nicht";
var returnedgoods_motivations_2="Das Produkt ist zu groß/klein";
var returnedgoods_motivations_3="Das Produkt ist geschädigt";
var returnedgoods_motivations_4="Das erhiletes Produkt stimmt nicht mit dem gewünschten Produkt überein";
var returnedgoods_motivations_5="Das Produkt ist nicht in der Packung";
var returnedgoods_motivations_other="Anders";
